import styled from 'styled-components';

import { Breakpoints } from '@lichtblick/theme';
import { Box } from '@lichtblick/ui-components';

export const Container = styled(Box)<{ $maxWidth?: number }>`
  margin: 0 auto;
  max-width: ${({ $maxWidth }) => ($maxWidth ? `${$maxWidth}px` : `${Breakpoints.Medium}px`)};
`;
